export enum EventParameter {
	AMMO_AMOUNT,
	AMMO_NAME,
	WEAPON_NAME,
	AREA_NAME,
	FAMILY_HOTKEY,
	HINT_STRING_KEY,
}
